import { PriceCard as PriceCardComponent } from './components';
import { PriceCardContainer } from './components/container';

export const PriceCard = Object.assign(PriceCardComponent, {
  Container: PriceCardContainer
});
